<section class="simulation-report-dialog">
  <header class="simulation-report-dialog__header">
    <div>
      <span class="simulation-report-dialog__eyebrow">Simulation Report</span>
      <h2 mat-dialog-title>Run Summary</h2>
    </div>
    <div class="simulation-report-dialog__header-actions">
      <button mat-icon-button type="button" aria-label="Export simulation PDF" (click)="exportPdf()">
        <span class="material-symbols-outlined">picture_as_pdf</span>
      </button>
      <button mat-icon-button mat-dialog-close aria-label="Close simulation report">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>
  </header>

  <mat-dialog-content class="simulation-report-dialog__content">
    <div class="simulation-report-dialog__progress" aria-hidden="true"></div>
    <article class="simulation-report-dialog__markdown mat-typography" [innerHTML]="reportHtml"></article>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
  </mat-dialog-actions>
</section>
